import React from 'react'
import { useSelector } from 'react-redux'

import { legendConfigs } from '../data/legendConfigs'

const Legend = ({ selectedLayer }) => {
  const theme = useSelector((state) =>
    state.mapStyle.darkMode ? 'dark' : 'light'
  )

  if (!legendConfigs[selectedLayer]) {
    return null
  }
  const config = legendConfigs[selectedLayer]

  return (
    <div
      className={`fixed bottom-8 left-1/2 transform -translate-x-1/2  shadow-xl rounded-full p-2 ${
        theme === 'dark' ? 'bg-[#353535]' : 'bg-white'
      } `}
    >
      {' '}
      <div className='flex items-center'>
        <div
          className={
            config.title === 'AQI'
              ? 'w-8 ml-6 mr-5 text-gray-400 pr-2 mb-2 '
              : 'w-24 ml-5 mr-8 text-gray-400 pr-2  mb-1'
          }
        >
          <span className='font-bold text-[11px]'>
            {config.title} <span>{config.units}</span>{' '}
          </span>
        </div>
        <div
          className={`flex flex-1 ${config.title !== 'AQI' ? 'pr-6' : 'pr-16'}`}
        >
          {config.values.map((value, i) => (
            <div className='flex-1' key={i}>
              <div
                className='h-1 w-10'
                style={{ backgroundColor: config.colors[i] }}
              />
              <div
                key={i}
                className={`text-left mt-1 text-xs ${
                  i !== 0 ? '-ml-2' : ''
                } text-gray-400 `}
              >
                <span
                  className={`${config.title !== 'AQI' ? '-ml-1' : 'ml-5'}`}
                >
                  {value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Legend
